import { LazyTaskFlow } from '../lazy/LazyTaskFlow'
import type { ProjectFlowProps } from '../project-flows'
import { AudioRecordingTask } from './AudioRecordingTask'

// /next returns { id, instruction, params, metadata }; the cast bridges only the NectarTask
// fields AudioRecordingTask never reads (type/projectId/timestamps/submissionCount).
export const AudioRecordingFlow = (props: ProjectFlowProps) => {
  return (
    <LazyTaskFlow
      {...props}
      renderBody={({ task }) => (
        <AudioRecordingTask
          taskId={task.id}
          taskIndex={props.progress.completed}
          projectId={props.projectId}
          captchaEnabled={props.captchaEnabled}
          taskReportingEnabled={props.taskReportingEnabled}
          onSubmitted={() => {}}
        />
      )}
    />
  )
}
